module.exports = "/dist/ljs/shared-c23eec41a88f762c0a76de920809af63.js";